import { Constants } from 'constants';

import React, { useState } from 'react';
import {
  Grid,
  Button,
  Input,
} from '@genie-ui/react';
import PropTypes from 'prop-types';
import DialogComponent from 'components/atoms/dialogcomponent';
import { isBusinessEmail, isValidEmail } from 'utils/Utilities';
import './email-dialog.scss';

function EmailDialog({
  openDialog,
  handleClose,
}) {
  const [email, setEmail] = useState('');

  const onChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  return (
    <DialogComponent
      open={openDialog}
      title={Constants.INVITATION_DIALOG.TITLE}
      modalClass="emailDialog__modal"
      modalRootClass="emailDialog__root"
      hideCloseButton
      content={(
        <div className="dialogSelect">
          <Input
            label={Constants.INVITATION_DIALOG.LABEL}
            placeholder={Constants.INVITATION_DIALOG.PLACEHOLDER}
            value={email}
            onChange={onChangeEmail}
          />
          {isValidEmail(email) && !isBusinessEmail(email) && (
          <div className="emailError">
            {Constants.INVITATION_DIALOG.NON_BUSINESS_EMAIL_ERROR}
          </div>
          )}
          <Grid container>
            <div>
              <Button
                variant="primary"
                className="agreeButton"
                onClick={handleClose(email)}
                disabled={!isBusinessEmail(email)}
              >
                {Constants.INVITATION_DIALOG.CONTINUE}
              </Button>
            </div>
          </Grid>
        </div>
        )}
    />
  );
}

EmailDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  openDialog: PropTypes.bool.isRequired,
};

export default EmailDialog;
